module.exports = __webpack_public_path__ + "static/media/logout.50828c48.svg";